/**
 * Slova pro zapamatovatelná hesla (Jahoda-modra-Kolo-47).
 *
 * Pravidla seznamu (Filip 2026-10-22, žáci ZŠ Horníkova):
 * - bez diakritiky — na školních stanicích se střídá česká a anglická klávesnice,
 * - bez y a z — mezi českou a anglickou klávesnicí se prohazují,
 * - bez w, q, x a bez slov na i, l, o — velké I/l a O/0 se pletou,
 * - 4 až 7 písmen, slova známá dětem.
 */
export const PASSWORD_NOUNS: readonly string[] = [
  'ananas', 'atlas', 'auto', 'autobus', 'anketa',
  'balon', 'banan', 'barva', 'beran', 'bota', 'buben', 'bunda', 'brambor', 'bobr', 'budova',
  'bratr', 'babka', 'batoh', 'buchta', 'barak', 'basnik', 'baterka',
  'cesta', 'citron', 'cibule', 'cukr', 'cena', 'cirkus', 'cesnek', 'cihla', 'cukrar',
  'datel', 'deka', 'dort', 'drak', 'duha', 'dudek', 'domek', 'deska', 'dravec', 'delfin',
  'dukat', 'dopis', 'dvere', 'dedek', 'dalnice',
  'fena', 'fialka', 'fotka', 'forma', 'fontana', 'fanfara',
  'guma', 'gong', 'gulas',
  'hora', 'hruska', 'houba', 'hrnek', 'hrad', 'holub', 'hudba', 'hrach', 'husa', 'hrebik',
  'hracka', 'hrnec', 'harfa', 'hlava', 'hokej',
  'jablko', 'jahoda', 'jaro', 'javor', 'jehla', 'jelen', 'jidlo', 'jmeno', 'jogurt', 'jedle',
  'kabat', 'kakao', 'kamen', 'kapr', 'karta', 'kasna', 'kocka', 'kolo', 'koruna', 'kostka',
  'krab', 'kreda', 'kruh', 'kuna', 'kure', 'kvetina', 'kniha', 'kotel', 'komin', 'kopec',
  'koberec', 'kohout', 'krtek', 'kachna', 'kaktus', 'kanoe', 'kapsa', 'kaple', 'klobouk',
  'klavir', 'kladivo', 'kmen', 'knoflik', 'kolac', 'kometa', 'koupel', 'kravata', 'kufr',
  'malina', 'mapa', 'masle', 'meloun', 'metla', 'misa', 'mlha', 'mrak', 'mrkev', 'mucha',
  'mesic', 'mesto', 'most', 'mince', 'minuta', 'morce', 'merunka', 'medved', 'mamut', 'motor',
  'noha', 'nora', 'nebe', 'nugat', 'nanuk', 'napoj', 'nakup', 'nadoba',
  'palec', 'papir', 'pavouk', 'pecivo', 'pero', 'pilot', 'pivonka', 'pocasi', 'podkova',
  'pohadka', 'pokoj', 'polevka', 'ponik', 'prase', 'pruh', 'ptacek', 'puding', 'pumpa',
  'panda', 'parek', 'pecka', 'pernik', 'pirat', 'plachta', 'pramen', 'prkno',
  'penal', 'perla', 'pisek', 'planeta', 'pondeli', 'potok', 'prstan',
  'raketa', 'robot', 'rohlik', 'ropucha', 'ruka', 'rubin', 'rodina', 'rampa', 'radio',
  'ranec', 'rebrik', 'recept',
  'salat', 'sane', 'seno', 'sklo', 'slon', 'slunce', 'sova', 'srdce', 'strom', 'svetlo',
  'skrin', 'smrk', 'sneh', 'sokol', 'struna', 'sukne', 'silnice', 'skala', 'skokan',
  'slepice', 'sliva', 'snidane', 'sobota', 'socha', 'stan', 'stul', 'sesit', 'semafor',
  'talir', 'tanec', 'taska', 'telefon', 'tenis', 'tesar', 'traktor', 'trava', 'tulen',
  'tunel', 'tabule', 'tecka', 'topol', 'tvaroh', 'trubka', 'turista', 'tuba',
  'ucho', 'ulice', 'uhel', 'ubrus', 'usmev', 'ucitel', 'ukol', 'uterek', 'uhlik',
  'vana', 'vata', 'vecer', 'vejce', 'veverka', 'vidle', 'vino', 'vitr', 'vlak', 'vlna',
  'voda', 'volant', 'vosa', 'vrana', 'vrabec', 'vanoce', 'vesnice', 'vlajka', 'vodnik',
  'vrba', 'vtip', 'vagon', 'vacek', 'vcela', 'veslo', 'vikend',
];

export const PASSWORD_ADJECTIVES: readonly string[] = [
  'modra', 'cervena', 'bila', 'cerna', 'hneda', 'seda', 'fialova',
  'velka', 'mala', 'pomala', 'vesela', 'silna', 'tepla', 'studena',
  'sladka', 'hlasita', 'ticha', 'nova', 'stara', 'dobra', 'krasna', 'mokra',
  'sucha', 'hladka', 'mekka', 'tvrda', 'svetla', 'tmava', 'dlouha',
  'kratka', 'siroka', 'cista', 'horka', 'chladna', 'mlada', 'hbita', 'smela',
  'plna',
];
